import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Grid, Typography } from '@mui/material';
import Credits from './Credits';

const footerSections = [
    {
        title: 'Game',
        links: [
            { label: 'Play Now', path: '/' },
            { label: 'Play vs Computer', path: '/play-against-computer' },
            { label: 'Play with Friends', path: '/play-with-friends' },
            { label: 'Daily Puzzle', path: '/daily' },
            { label: 'Leaderboard', path: '/leaderboard' },
            { label: 'My games', path: '/my-games' },
            { label: 'How to Play', path: '/how-to-play' },
            { label: 'Strategy Guide', path: '/strategy' },
            { label: 'How Many Players', path: '/how-many-players' },
            { label: 'FAQ', path: '/faq' },
        ]
    },
    {
        title: 'About',
        links: [
            { label: 'About Us', path: '/about' },
            { label: 'Contact', path: '/contact' },
        ]
    },
    {
        title: 'Legal',
        links: [
            { label: 'Privacy Policy', path: '/privacy-policy' },
            { label: 'Terms of Service', path: '/terms' },
        ]
    }
];

const Footer = () => {
    return (
        <Box component="footer" sx={{ backgroundColor: '#071C16', color: '#fff', pt: 6, pb: 4 }}>
            <Container maxWidth="lg">
                <Grid container spacing={4}>
                    {footerSections.map((section) => (
                        <Grid item xs={12} sm={4} key={section.title}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2, color: '#fff' }}>
                                {section.title}
                            </Typography>
                            {section.links.map((link) => (
                                <Typography key={link.path} sx={{ mb: 1 }}>
                                    <Link
                                        to={link.path}
                                        style={{
                                            color: 'rgba(255,255,255,0.7)',
                                            textDecoration: 'none',
                                            fontSize: '0.9rem',
                                        }}
                                    >
                                        {link.label}
                                    </Link>
                                </Typography>
                            ))}
                        </Grid>
                    ))}
                </Grid>
                <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.1)', mt: 4, pt: 3, textAlign: 'center' }}>
                    <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.5)' }}>
                        <Credits />
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;
